import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { CyborgUIModule } from '@cyborg-monorepo/common/angular/cyborg-ui';
import { BreadcrumbsComponent } from '../shared/components/breadcrumbs/breadcrumbs.component';
import { CollectionComponent } from '../shared/components/collection/collection.component';
import { CyborgFilterComponent } from '../shared/components/cyborg-filter/cyborg-filter.component';
import {
  CollectionAddedToHuntComponent,
  CollectionAddedToTemplateComponent,
  HuntPackAddedToHuntComponent,
  HuntPackAddedToTemplateComponent,
  MarkCopiedComponent,
  MarkDeployedComponent,
  MarkRemovedComponent,
  MarkResetComponent,
  MarkSavedComponent,
  MarkStagedComponent,
} from '../shared/components/cyborg-snackbar/cyborg-snackbar';
import { DeploymentQueueComponent } from '../shared/components/deployment-queue/deployment-queue';
import { AddToQuickHuntDialogComponent } from '../shared/components/dialogs/add-to-quick-hunt-dialog/add-to-quick-hunt-dialog.component';
import { AddToTemplateDialogComponent } from '../shared/components/dialogs/add-to-template-dialog/add-to-template-dialog.component';
import { FeedbackModalComponent } from '../shared/components/dialogs/feedback-modal/feedback-modal.component';
import { MitreCardComponent } from '../shared/components/mitre-card/mitre-card-component';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './components/filter/components/dashboard/dashboard.component';
import { MitreComponent } from './components/filter/components/dashboard/mitre/mitre.component';
import { MyEnvComponent } from './components/filter/components/dashboard/my-env/my-env.component';
import { HuntPackageContentComponent } from './components/filter/components/dashboard/recently-updated/recently-updated.component';
import { EmergingComponent } from './components/filter/components/dashboard/emerging/emerging.component';
import { FilterComponent } from './components/filter/filter.component';
import { SearchComponent } from './components/filter/search/search.component';
import { DrillDownHuntPackageComponent } from './components/hunt-package/hunt-package.component';
import { DrillDownThreatProfileComponent } from './components/threat-profiles/threat-profiles.component';
import { ResearchComponent } from './research.component';
import { ResearchRoutes } from './research.routing';
import { BreadcrumbsDataService } from './services/breadcrumbs.service';
import { SearchDataService } from './services/search-data.service';
import { BadgeComponent, CheckboxComponent, LinkComponent, RadioButtonComponent, SearchInputComponent, TabBarComponent, TabComponent, TagComponent, TypographyComponent } from '@hyperkit';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ResearchComponent,
    CyborgFilterComponent,
    FilterComponent,
    CollectionComponent,
    EmergingComponent,
    SearchComponent,
    MitreComponent,
    HuntPackageContentComponent,
    MyEnvComponent,
    DashboardComponent,
    DeploymentQueueComponent,
    MitreCardComponent,
    DrillDownHuntPackageComponent,
    DrillDownThreatProfileComponent,
    MarkDeployedComponent,
    MarkStagedComponent,
    MarkRemovedComponent,
    MarkCopiedComponent,
    MarkSavedComponent,
    MarkResetComponent,
    HuntPackAddedToHuntComponent,
    HuntPackAddedToTemplateComponent,
    CollectionAddedToHuntComponent,
    CollectionAddedToTemplateComponent,
    FeedbackModalComponent,
    AddToTemplateDialogComponent,
    AddToQuickHuntDialogComponent,
  ],
  providers: [SearchDataService, BreadcrumbsDataService],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule.forChild(ResearchRoutes),
    CyborgUIModule,
    TypographyComponent,
    TabBarComponent,
    TabComponent,
    CheckboxComponent,
    RadioButtonComponent,
    TagComponent,
    SearchInputComponent,
    BadgeComponent,
    LinkComponent
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ResearchModule {}
